import React, { 
    useState, 
    useEffect 
} from 'react';
import axios from 'axios';
import moment from "moment";

// componentes
import { 
    Card, 
    Col, 
    Form,
    Row, 
    Button, 
    Container 
} from 'react-bootstrap';
import { 
    useSelector, 
    useDispatch 
} from 'react-redux';
import { 
    useHistory, 
    useLocation 
} from 'react-router-dom';
import { EventosCartaOfertaComponent } from './components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faSpinner } from '@fortawesome/free-solid-svg-icons';
import Carregador from './../../../Painel/Componentes/Carregador';
import PaginacaoComponente from './../../../Painel/Componentes/Paginacao';
import ModalConfirmar from '../../../Painel/Componentes/ModalConfirmar';
import Registro from './Registro';

import { intersectObject } from '../../../Funcoes';
import logoTipoAventura from './../../../../assets/rocaSeguroAventura.png';
import ModalParticipantes from './ModalParticipantes';
import Parametros from './Parametros';

import FechamentosCartaOferta from "./../FechamentosCartaOferta";
import ModalBoletos from './ModalBoletos';
import ModalDadosUsuario from './ModalDadosUsuario';

export default function EventosCartaOferta(){

    const dispatch = useDispatch();
    const { search } = useLocation();
    const dadosCartaOferta = useSelector(state => state.cartaOferta);
    
    // estados
    const history = useHistory();

    // resgata dia atual
    const diaAtual = parseInt(moment().format('D') ?? '0');
    
    const [parametros, alterarParametros] = useState({
        pagina: 1,
        registrosPorPagina: 10,
        ativo: ['S'],
        texto: '',
        textoPesquisaParticipante: '',
        dataProgramadoInicio: null,
        dataProgramadoFim: null,
        estados: []
    });
    const [loginViaPainel, alterarLoginViaPainel] = useState(false);
    const [totalRegistros, alterarTotalRegistros] = useState(0);
    const [mostrarDadosUsuario, alterarMostrarDadosUsuario] = useState(false);
    const [carregando, alterarCarregando] = useState(false);
    const [carregandoAlteracaoPropriedade, alterarCarregandoAlteracaoPropriedade] = useState(false);
    const [possuiEventoGerarBoleto, alterarPossuiEventoGerarBoleto] = useState(false);
    const [mostrarModalBoletos, alterarMostrarModalBoletos] = useState(false);
    const [registros, alterarRegistros] = useState([]);
    const [erros, alterarErros] = useState({});
    const [buscando, alterarBuscando] = useState(false);
    const [alertaCloneEvento, alterarAlertaCloneEvento] = useState({
        mostrar: false,
        token: null
    });
    const [alertaConfirmarClonarParticipantes, alterarAlertaConfirmarClonarParticipantes] = useState({ mostrar: false });
    const [gerandoApolice, alterarGerandoApolice] = useState(false);
    const [modalParticipantes, alterarModalParticipantes] = useState(null);
    const [mostrarTabela, alterarMostrarTabela] = useState(false);
    const [possuiGrupoPropriedade, alterarPossuiGrupoPropriedade] = useState(false);
    const [dadosCliente, alterarDadosCliente] = useState(null);
    const [meses, alterarMeses] = useState(null);  
    
    // função com o objetivo de atualizar o objeto que está no cachê com informações do banco
    function montaClienteInterseccao(cliente) {

        // prepara objeto para atualiza cachê
        const montaClienteObjeto = {
            tipoPessoa: cliente.tipoPessoa,
            nomeEvento: cliente.seguroEventoNome,
            localEvento: cliente.seguroEventoLocal,
            descricao: cliente.seguroEventoDescricao,
            numeroApolice: cliente.numeroApolice,
            cartaOferta: cliente.cartaOferta,
            bloquearEnvioEmailsSeguroAventura: cliente.bloquearEnvioEmailsSeguroAventura
        };

        // caso seja pessoa física
        if(montaClienteObjeto.tipoPessoa === 'F') {

            // atribui informações de pessoa física ao objeto
            montaClienteObjeto['responsavel'] = cliente.nome;
            montaClienteObjeto['cpf'] = cliente.cpf;
            montaClienteObjeto['email'] = cliente.email;
            montaClienteObjeto['telefone'] = cliente.telefoneComercial;

        } else {

            // atribui informações de pessoa jurídica ao objeto
            montaClienteObjeto['responsavel'] = cliente.responsavelJuridicoNome;
            montaClienteObjeto['cnpj'] = cliente.cnpj;
            montaClienteObjeto['razaoSocial'] = cliente.nome;
            montaClienteObjeto['email'] = cliente.responsavelJuridicoEmail;
            montaClienteObjeto['telefone'] = cliente.responsavelJuridicoTelefone;

        }
        
        // atualiza o cache
        dispatch({
            type: 'cartaOferta/ATUALIZAR',
            dados: intersectObject(dadosCartaOferta.dados, montaClienteObjeto)
        });

    }

    // função para consultar eventos da carta oferta
    async function consultarCartaOferta(cancelToken){
        alterarCarregando(true);
        alterarErros({});

        try {
            
            // faz a requisição
            const { data } = await axios.get(`/seguroAventura/eventosCartaOferta`, {
                params: parametros,
                cancelToken
            });

            // prepara para verificar se algum evento está disponível para gerar boleto
            let possuiEventoParaGerarBoleto = false;            
            
            // atualiza os estados
            alterarMeses(data.somatorioMeses);
            alterarDadosCliente(data.cliente);
            montaClienteInterseccao(data.cliente);
            alterarTotalRegistros(parseInt(data.totalRegistros));
            alterarRegistros(data.registros.map((registro) => {
                
                // verifica se possui evento disponível para gerar boleto
                if(
                    !possuiEventoParaGerarBoleto && 
                    registro.permiteGerarBoleto && 
                    !registro.linkBoleto && 
                    diaAtual <= 25 &&
                    parseInt(registro.quantidadeParticipantes) > 0
                ) possuiEventoParaGerarBoleto = true; 

                return registro
            }));            
            // se ja podia gerar boleto, deixa gerar mesmo com os filtros
            alterarPossuiEventoGerarBoleto(possuiEventoGerarBoleto ? possuiEventoGerarBoleto : (
                data.possuiEventoFinalizadoEmAberto === "S" ? true : possuiEventoParaGerarBoleto
            ));
            alterarPossuiGrupoPropriedade(data.possuiGrupoPropriedade);
            alterarMostrarTabela(true);

            // salva no navegador para não precisar consultar novamente
            dispatch({
                type: 'cartaOferta/ATUALIZAR',
                dados: {
                    ...dadosCartaOferta.dados,
                    cadastroParticipanteNome: data.cliente.cadastroParticipanteNome
                }
            });

        } catch (error) {
            if(axios.isCancel(error)) return;

            const response = error?.response;
            if(response && response.status && response.status === 400){
                if(response.data) {
                    alterarErros(response.data);
                    if(response.data.cartaOferta && response.data.cartaOferta === 'Não encontrado') {
                        dispatch({
                            type: 'cartaOferta/ATUALIZAR',
                            dados: null
                        });
                    }
                } 
            }
        } finally {
            alterarCarregando(false);
            alterarBuscando(false);
        }


    }    
    
    // função responsável por gerar o arquivo apólice do cliente
    async function gerarArquivoApolice() {

        // ativa carregamento da apólice
        alterarGerandoApolice(true);

        try {

            // realiza a requisiçaõ para download do arquivo
            const { data } = await axios.get(`/seguroAventura/pdfArquivoApolice`);

            // faz o download
            window.open(
                `${process.env.REACT_APP_URL_ARQUIVOS}/download.php?p=anexosEmail&f=${encodeURIComponent(data.temporario)}&n=${encodeURIComponent(data.nome)}`,
                '_blank'
            );

        } catch(e) {

            console.log(e);

        } finally {

            // desativa carregamento da apólice
            alterarGerandoApolice(false);

        }

    }
    
    // atualiza permissão dos eventos do tipo propriedade
    async function atualizarPermissaoEventoPropriedade(bloqueado) {

        // aplica o carregamento
        alterarCarregandoAlteracaoPropriedade(true);

        try {

            // atualiza status dos eventos
            const { data } = await axios.post(`/clientes/salvarComJwt`, {
                id: dadosCliente.id,
                seguroPropriedadeBloqueado: bloqueado
            });
            alterarDadosCliente(data.dados);

        } catch(e) {
            console.error(e);
        } finally {
            // desativa o carregamento
            alterarCarregandoAlteracaoPropriedade(false);
        }

    }   

    useEffect(() => {        
        // se veio por meio da url
        if(search && search.length > 0) {

            // resgata parametros passados na url
            const parametrosUrl = new URLSearchParams(document.location.search);

            // resgata parametros
            const loginPainel = parametrosUrl.get("loginViaPainel"); 
            
            // caso for login via painel, atualiza o estado
            if(loginPainel) alterarLoginViaPainel(loginPainel === "S");

        }
    }, []);
    
    // inicia
    useEffect(() => {
        const cancelTokenSource = axios.CancelToken.source();
        consultarCartaOferta(cancelTokenSource.token);

        return () => {
            // ao desmontar componente, cancela a requisição
            cancelTokenSource.cancel('Nova consulta iniciada ou componente desmontado');
        };
    }, [parametros]);    
    
    return (
        <EventosCartaOfertaComponent>
            <Container>
                <Row className="align-center justify-content-center">
                    <div className="formulario">                  
                        <div className='container-bem-vindo'>
                            <div className='container-background-texto'>
                                <div className='container-titulo-icone'>
                                    <p className='titulo-bem-vindo'>Bem vindo</p>
                                    <button 
                                        className='botao-icone-usuario'
                                        onClick={() => alterarMostrarDadosUsuario(true)}
                                    >
                                        <FontAwesomeIcon 
                                            className="icone" icon={["fa", "user"]} 
                                        />
                                    </button>
                                </div>
                                <p className='nome-usuario'>{dadosCliente?.nome ?? ''}</p>
                            </div>
                        </div>     
                        <div className="logo">
                            <img src={logoTipoAventura} />
                        </div>
                        <div className='container-opcoes-topbar'>
                            <div className='botao-sinistro'>
                                <Button 
                                    variant="padrao-azul" 
                                    className="botao-cadastrar"
                                    onClick={() => window.open('https://seguroaventura.com.br/comunicar-sinistro')}
                                >
                                    <FontAwesomeIcon className="icone" icon={["fas", "exclamation-triangle"]} />
                                    <span>Comunicar Sinistro</span>
                                </Button>
                            </div>
                            {(possuiGrupoPropriedade) &&
                                <>
                                    {(!carregandoAlteracaoPropriedade) ? 
                                        <Form.Switch
                                            type="switch"
                                            label={dadosCliente.seguroPropriedadeBloqueado === "N" ? "Inscrição via QRCODE Habilitado" : "Inscrição via QRCODE Desabilitados"}                            
                                            color='white'
                                            checked={dadosCliente.seguroPropriedadeBloqueado === "N"}
                                            onChange={() => atualizarPermissaoEventoPropriedade(
                                                dadosCliente.seguroPropriedadeBloqueado === "S" ? "N" : "S"
                                            )}
                                        /> : 
                                        <FontAwesomeIcon 
                                            color='white'
                                            size={'2x'}
                                            icon={faSpinner} 
                                            pulse 
                                        />
                                    }
                                </>
                            }
                        </div>
                    </div>
                </Row>
                <Row className='p-3 bg-white rounded mt-3 mb-3 ml-0 mr-0' style={{ fontSize: '14px' }}>
                    <Col className="p-0 flex-column justify-content-between d-flex col-6">
                        <div className='d-flex align-itens-center justify-content-center mb-2 font-weight-bold'>
                            <span 
                                className='bg-white p-2 rounded w-auto text-center border border-dark'
                                style={{ boxShadow: '0px 0px 0px 1px black' }}
                            >
                                COBERTURAS DO SEGURO
                            </span>
                        </div>
                        <Row className='flex-row d-flex align-center' style={{ gap: '5px' }}>
                            <Col className='d-flex justify-content-end align-center text-align-center flex-column'>
                                <span>Valor morte acidental</span>
                                <span className='d-flex w-100 p-1 mt-2 rounded border' style={{ background: '#e9ecef' }}>
                                    R$ {dadosCliente ? dadosCliente.seguroValorMorteAcidental : '0.00'}
                                </span>
                            </Col>
                            <Col className='d-flex justify-content-end align-center flex-column'>
                                <span>Valor invalidez</span>
                                <span className='d-flex w-100 p-1 mt-2 rounded border' style={{ background: '#e9ecef' }}>
                                    R$ {dadosCliente ? dadosCliente.seguroValorInvalidez : '0.00'}
                                </span>
                            </Col>
                            <Col className='d-flex justify-content-end align-center flex-column'>
                                <span>Valor DMHO</span>
                                <span className='d-flex w-100 p-1 mt-2 rounded border' style={{ background: '#e9ecef' }}>
                                    R$ {dadosCliente ? dadosCliente.seguroValorDmho : '0.00'}
                                </span>
                            </Col>
                        </Row>
                    </Col>
                    <Col className="p-0 flex-column justify-content-between d-flex col-6" style={{ alignItems: 'flex-end' }}>                    
                        <div className='d-flex align-itens-center justify-content-end text-align-center mb-2 font-weight-bold' style={{ zIndex: 1 }}>
                            <span 
                                className='bg-white p-2 rounded w-auto text-center border border-dark' 
                                style={{ boxShadow: '0px 0px 0px 1px black' }}
                            >
                                VALOR POR PESSOA/DIA
                            </span>
                        </div>
                        <div className='d-flex justify-content-end text-end flex-column' style={{ alignItems: 'flex-end' }}>
                            <span className='text-end'>Valor</span>
                            <span className='d-flex w-auto p-1 mt-2 rounded border justify-content-end' style={{ background: '#e9ecef', minWidth: '180px' }}>
                                R$ {dadosCliente ? dadosCliente.seguroValorDiaria : '0.00'}
                            </span>
                        </div>                    
                    </Col>
                </Row>            

                {
                    mostrarTabela &&
                    <>
                        <Card className="painel-consulta border-0 shadow-sm mb-3" >
                            <div className="card-header">
                                <Parametros 
                                    parametros={parametros} 
                                    permissaoCriarEvento={dadosCartaOferta?.dados?.clienteGrupoSuspenso === "N"}
                                    gerandoApolice={gerandoApolice}
                                    alterarParametros={alterarParametros}
                                    gerarApoliceCliente={gerarArquivoApolice}
                                    possuiEventoGerarBoleto={loginViaPainel ? loginViaPainel : (possuiEventoGerarBoleto && diaAtual <= 25)}
                                    alterarMostrarModalBoletos={alterarMostrarModalBoletos}
                                />
                            </div>
                            
                            <Card.Body className="pt-0">
                                <table className="table table-hover tabela">
                                    <thead>
                                        <tr>
                                            <th className="text-center"><FontAwesomeIcon icon={faUsers} /></th>
                                            <th>Evento</th>
                                            <th>Local</th>
                                            <th>Data início</th>
                                            <th>Data fim</th>
                                            {meses && 
                                                <>
                                                    <th>{moment(meses[1]).format("MMMM")}</th>
                                                    <th>{moment(meses[2]).format("MMMM")}</th>
                                                </>
                                            }
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {registros.map((registro, a) => 
                                            <Registro 
                                                key={registro.dados.id}
                                                dados={registro}
                                                clicouAbrir={() => {
                                                    alterarModalParticipantes({
                                                        idSeguroAventura: registro.dados.id,
                                                        evento: registro.dados
                                                    });
                                                }}
                                                cliente={dadosCliente}
                                                editarEvento={(clone=false) => {
                                                    if(clone) {

                                                        // ativa alerta
                                                        alterarAlertaCloneEvento({
                                                            mostrar: true,
                                                            token: registro.dados.token
                                                        });
                                                    } else {
                                                        history.push(`/formularios/propostaSeguro/evento/${registro.dados.token}`);   
                                                    }
                                                }}
                                            />
                                        )}
                                    </tbody>
                                </table>
                                <PaginacaoComponente
                                    pagina={parametros.pagina}
                                    registrosPorPagina={parametros.registrosPorPagina}
                                    totalRegistros={totalRegistros}
                                    alterouPagina={(pagina) => {
                                        alterarParametros({...parametros, pagina: pagina});
                                    }}
                                />
                                {carregando && 
                                    <Carregador className="rounded-bottom" />
                                }
                            </Card.Body>
                        </Card>

                        <FechamentosCartaOferta />
                    </>
                }
            </Container>

            {mostrarDadosUsuario &&
                <ModalDadosUsuario 
                    idCliente={dadosCliente.id}
                    dadosCliente={dadosCliente}
                    alterarDadosCliente={alterarDadosCliente}
                    fechou={() => alterarMostrarDadosUsuario(false)}
                />
            }
        
            {modalParticipantes && (
                <ModalParticipantes 
                    {...modalParticipantes}
                    fechou={() => {
                        alterarModalParticipantes(null);
                    }}
                />
            )}

            {mostrarModalBoletos && (
                <ModalBoletos 
                    cliente={dadosCliente}
                    loginViaPainel={loginViaPainel}
                    mostrarModalBoletos={mostrarModalBoletos}
                    alterarMostrarModalBoletos={alterarMostrarModalBoletos}  
                />
            )}

            <ModalConfirmar
                mostrar={alertaCloneEvento.mostrar}
                titulo={'Clonar Evento'}
                texto={`Você deseja clonar este evento para outra data?`}
                clicouCancelar={() => alterarAlertaCloneEvento({ mostrar: false, token: null })}
                clicouConfirmar={() => {
                    alterarAlertaCloneEvento({ mostrar: false, token: alertaCloneEvento.token });
                    alterarAlertaConfirmarClonarParticipantes({ mostrar: true });
                }}
                carregando={false}
            />

            <ModalConfirmar
                mostrar={alertaConfirmarClonarParticipantes.mostrar}
                titulo={'Clonar Participantes'}
                texto={`Você deseja clonar os participantes deste evento?`}
                textoBotaoCancelar={"Não"}
                clicouCancelar={() => {
                    alterarAlertaConfirmarClonarParticipantes({ mostrar: false });

                    history.push(`/formularios/propostaSeguro/evento/${alertaCloneEvento.token}`, {
                        cloneEvento: true,
                        clonarParticipantes: false
                    });
                }}
                textoBotaoConfirmar={"Sim"}
                clicouConfirmar={() => {
                    alterarAlertaCloneEvento({ mostrar: false, token: null });

                    history.push(`/formularios/propostaSeguro/evento/${alertaCloneEvento.token}`, {
                        cloneEvento: true,
                        clonarParticipantes: true
                    });
                }}
                carregando={false}
            />

        </EventosCartaOfertaComponent>
    )
}
